import React, { Component } from 'react';
import error from '../../../../../Images/Cell_Status_Icon/error.png';

export default class Error_Message extends Component {
	constructor(props) {
		super(props);
	}

	render() {
		return (
			<div style={{ margin: 10, padding: 10, borderRadius: 20, boxShadow: 'rgb(0 0 0 / 20%) 0px 0px 3px', width: '80%', display: 'inline-block', maxWidth: '80%', visibility: this.props.deviceErrorMessage == '' ? 'collapse' : 'visible' }}>
				<div style={{ display: 'inline-block', float: 'left', maxWidth: '10%' }}>
					<img src={error} style={{ width: 25 }} />
				</div>
				<div style={{ display: 'inline-block', float: 'right', maxWidth: '90%', textAlign: 'end' }}>
					<span> {this.props.deviceErrorMessage} </span>
				</div>
			</div>
		)
	}
}
